var exports = {
  "k": "xcc377c0b--9ce609--container",
  "K": "xcc377c0b--9ce609--icon",
};

module.exports = exports;
